import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var home_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12 4L4 7.9V20h16V7.9L12 4zm6.5 14.5H14V13h-4v5.5H5.5V8.8L12 5.7l6.5 3.1v9.7z" }) });
export {
  home_default as default
};
//# sourceMappingURL=home.js.map
